import { gql } from 'graphql-tag';

const GET_UNIVERSITY = gql`
	query getUniversity($universityUrl: String!, $product: Product!) {
		university(slug: $universityUrl) {
			id
			name
			logo
			slug
			address {
				street
				region
				postcode
				maps
			}
			paid_features
			privacy_policy_url
			saved
			order
			stats {
				reviews_count
				total_students
				full_time_students_percentage
				apprenticeship_students
				rank_position
				recommended_percentage
				rating
				students_in_hall
				average_entry_tariff
			}
			seo {
				title
				description
				keywords
			}
			undergraduate: profile(product: UNDERGRADUATE) {
				external_url
				cover_image
				external_prospectus_url
				external_events_url
			}
			postgraduate: profile(product: POSTGRADUATE) {
				external_url
				cover_image
				external_prospectus_url
				external_events_url
			}
		}
		universityGallery(university: $universityUrl, product: $product) {
			images {
				path
				position
			}
			video {
				url
				thumbnail
			}
		}
		universitySections(university: $universityUrl, product: $product) {
			overview
		}
	}
`;

const GET_CLEARING_UNIVERSITY = gql`
	query getClearingUniversity($uniSlug: String!) {
		clearingUniversity(slug: $uniSlug) {
			id
			name
			logo
			address {
				street
				postcode
				maps
				region
			}
			paid_features
			stats {
				reviews_count
				total_students
				full_time_students_percentage
				apprenticeship_students
				students_in_hall
				average_entry_tariff
				rank_position
				recommended_percentage
				rating
			}
			seo {
				title
				description
				keywords
			}
			phone_number
			external_url
			privacy_policy_url
			phone_number
			saved
			slug
			cover_image
			gallery {
				path
				position
			}
			overview
			usp {
				image
				text
			}
			video {
				url
				thumbnail
			}
			order
		}
	}
`;

const UPDATE_UNIVERSITY_OVERVIEW = gql`
	query updateUniversityOverview($universityUrl: String!, $product: Product!) {
		universitySections(university: $universityUrl, product: $product) {
			overview
		}
	}
`;

const UPDATE_UNIVERSITY_GALLERY = gql`
	query updateUniversityGallery($universityUrl: String!, $product: Product!) {
		universityGallery(university: $universityUrl, product: $product) {
			images {
				path
				position
			}
			video {
				url
				thumbnail
			}
		}
	}
`;

const GET_UNIVERSITY_SECTIONS = gql`
	query getUniversitySections($universityUrl: String!, $product: Product!) {
		universitySections(university: $universityUrl, product: $product) {
			overview
			external_campus_url
			external_tuition_fees_url
			external_information_url
			job_prospects {
				image
				text
			}
			courses_lectures {
				image
				text
			}
			accommodation {
				image
				text
			}
			city_life {
				image
				text
			}
			student_life {
				image
				text
			}
			student_support {
				image
				text
			}
			university_facilities {
				image
				text
			}
			clubs_societies {
				image
				text
			}
			student_union {
				image
				text
			}
			tuition_fees {
				image
				text
			}
			scholarships_bursaries {
				image
				text
			}
		}
	}
`;

const GET_ACCOMMODATIONS = gql`
	query getAccommodations($university: String!) {
		universityAccommodations(university: $university) {
			rank
			rating
			external_url
			locations {
				name
				price
				total_rooms
				postcode
				image
			}
		}
	}
`;

const GET_UNIVERSITY_REVIEWS = gql`
	query getUniversityReviews(
		$university: String!
		$page: Int!
		$limit: Int!
		$contains: String
		$offset: Int
		$sortBy: UniversityReviewSortBy!
	) {
		universityReviews(
			university: $university
			page: $page
			limit: $limit
			contains: $contains
			offset: $offset
			sort_by: $sortBy
		) {
			data {
				id
				title
				rating
				avatar
				username
				subject
				published_at
				comment
				likes
				dislikes
				reply
				reaction
			}
			top {
				id
				title
				rating
				avatar
				username
				subject
				published_at
				comment
				likes
				dislikes
				reply
				reaction
			}
			total
			per_page
			current_page
			has_more_pages
		}
	}
`;

const GET_UNIVERSITY_REVIEW = gql`
	query getUniversityReview($reviewId: Int!) {
		universityReview(id: $reviewId) {
			id
			title
			rating
			avatar
			username
			subject
			published_at
			comment
			likes
			dislikes
			reply
			reaction
		}
	}
`;

const GET_UNIVERSITY_RATING_STATS = gql`
	query getUniversityRatings($university: String!) {
		universityRatings(university: $university) {
			accommodation
			graduate_careers
			course_quality
			social_life
			stars {
				one
				two
				three
				four
				five
			}
		}
	}
`;

export {
	GET_UNIVERSITY,
	GET_CLEARING_UNIVERSITY,
	UPDATE_UNIVERSITY_OVERVIEW,
	UPDATE_UNIVERSITY_GALLERY,
	GET_ACCOMMODATIONS,
	GET_UNIVERSITY_REVIEWS,
	GET_UNIVERSITY_RATING_STATS,
	GET_UNIVERSITY_SECTIONS,
	GET_UNIVERSITY_REVIEW,
};
